import { supabase } from '@/lib/supabase';

export type GetProjectInvitationInput = {
  invitationToken: string;
};

export type GetProjectInvitationResult = Awaited<
  ReturnType<typeof getProjectInvitation>
>;

export const getProjectInvitation = async ({
  invitationToken,
}: GetProjectInvitationInput) => {
  const { data, error } = await supabase
    .from('project_member_invites')
    .select(
      '*, project:projects(*), org_member:org_members!inner(*, profiles:profiles(*))',
    )
    .eq('invitation_token', invitationToken)
    .single();

  if (error) {
    throw error;
  }

  return data;
};
